import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ImageSrcService } from 'src/app/shared/images/image-src.service';
import { ShopLogoUrlPipe } from 'src/app/shared/pipes/shop-logo-url.pipe';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';

/**
 * Keep this component only to save compatibility with metronic
 */
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
})
export class SplashScreenComponent {
  public logoUrl$: Observable<string>;

  constructor(
    whiteLabelService: WhiteLabelService,
    imageSrcService: ImageSrcService,
    shopLogoUrlPipe: ShopLogoUrlPipe,
  ) {
    this.logoUrl$ = whiteLabelService.isWhiteLabel
      ? imageSrcService.loadImage(shopLogoUrlPipe.transform(whiteLabelService.dataSnapshot.shopId))
      : of('./assets/media/logos/adshero_blue.svg');
  }
}
